import { render, staticRenderFns } from "./RecyclableMaterialReport.vue?vue&type=template&id=0b86c1d0&scoped=true&"
import script from "./RecyclableMaterialReport.vue?vue&type=script&lang=js&"
export * from "./RecyclableMaterialReport.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableMaterialReport.vue?vue&type=style&index=0&id=0b86c1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86c1d0",
  null
  
)

export default component.exports